const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-32 pb-20">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <div className="mb-8">
          <span className="inline-block bg-[#94cf1c] px-3 py-1 text-xs font-bold uppercase tracking-wider text-white">
            Contrato de Adhesión
          </span>
          <h1 className="mt-4 text-4xl font-bold text-[#0A2540]">
            Términos y Condiciones
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <p className="text-sm text-slate-600 mt-1">
            Con fundamento en el artículo 85 de la Ley Federal de Protección al Consumidor
          </p>
        </div>

        <div className="prose prose-slate max-w-none">
          <div className="bg-[#0A2540]/5 border-l-4 border-[#94cf1c] p-6 rounded-r mb-8">
            <p className="text-sm text-slate-700">
              El presente documento constituye un <strong>contrato de adhesión</strong>
              en términos del artículo 85 de la <strong>Ley Federal de Protección al Consumidor</strong>.
              Al utilizar nuestros servicios, usted acepta los siguientes términos y condiciones.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            1. Aceptación de los Términos
          </h2>
          <p className="text-slate-600">
            Al acceder y utilizar este sitio web y nuestros servicios, usted acepta
            quedar vinculado por estos Términos y Condiciones.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            2. Descripción del Servicio
          </h2>
          <p className="text-slate-600">
            CLEAN WORK ofrece servicios profesionales de limpieza para empresas,
            incluyendo:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Limpieza de oficinas y edificios</li>
            <li>Mantenimiento de hoteles y restaurantes</li>
            <li>Limpieza de cocinas industriales</li>
            <li>Servicios de limpieza para instituciones educativas</li>
            <li>Mantenimiento de áreas públicas y comerciales</li>
            <li>Servicios especializados de limpieza</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            3. Cotizaciones y Presupuestos
          </h2>
          <p className="text-slate-600">
            Las cotizaciones proporcionadas a través de nuestro formulario son
            estimaciones basadas en la información proporcionada. El presupuesto
            final puede variar después de una visita a las instalaciones para
            evaluar las necesidades específicas.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            4. Responsabilidades del Cliente
          </h2>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Proporcionar información precisa y veraz sobre las instalaciones</li>
            <li>Garantizar el acceso a las áreas a limpiar</li>
            <li>Notificar sobre áreas restringidas o materiales sensibles</li>
            <li>Realizar el pago conforme a los términos acordados</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            5. Cancelación y Modificaciones
          </h2>
          <p className="text-slate-600">
            Las cancelaciones o modificaciones de servicios deben notificarse
            con al menos 48 horas de anticipación. Para cambios de última
            hora, contacta directamente a nuestro equipo de atención.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            6. Propiedad Intelectual
          </h2>
          <p className="text-slate-600">
            Todo el contenido de este sitio web, incluyendo textos, imágenes,
            logotipos y diseño, es propiedad de CLEAN WORK y está protegido por
            las leyes de propiedad intelectual.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            7. Limitación de Responsabilidad
          </h2>
          <p className="text-slate-600">
            CLEAN WORK no se hace responsable por daños indirectos o pérdidas
            derivadas del uso de este sitio web o de nuestros servicios,
            siempre que actuemos de acuerdo con las mejores prácticas de la industria
            y en cumplimiento de la normativa aplicable.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            8. Protección al Consumidor
          </h2>
          <p className="text-slate-600">
            De conformidad con la <strong>Ley Federal de Protección al Consumidor</strong>,
            usted tiene derecho a:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Recibir información clara y veraz sobre los servicios</li>
            <li>Presentar quejas ante PROFECO en caso de incumplimiento</li>
            <li>Contar con garantías sobre los servicios contratados</li>
          </ul>
          <div className="bg-slate-100 p-4 rounded border border-slate-200 mt-2">
            <p className="text-sm text-slate-600">
              <strong>📞 Contacto PROFECO:</strong> Teléfono del Consumidor 55 5568 8722
              y 800 468 8722
            </p>
          </div>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            9. Ley Aplicable y Jurisdicción
          </h2>
          <p className="text-slate-600">
            Estos Términos y Condiciones se rigen por las leyes de México.
            Cualquier disputa será resuelta en los tribunales competentes de
            San Juan del Río, Querétaro.
          </p>

          <h2 className="text-2xl font-bold text-[#0A2540] mt-8 mb-4">
            10. Contacto
          </h2>
          <p className="text-slate-600">
            Para cualquier pregunta sobre estos Términos y Condiciones,
            contáctenos a través de:
          </p>
          <div className="bg-slate-100 p-4 rounded border border-slate-200 mt-2">
            <p className="text-sm text-slate-700">
              <strong>Correo electrónico:</strong>{' '}
              <a href="mailto:aydnieto@gmail.com" className="text-[#00a7e2] hover:underline">
                aydnieto@gmail.com
              </a>
              <br />
              <strong>Teléfono:</strong> (427) 110 7773
              <br />
              <strong>Domicilio:</strong> Norte 3 núm. 24 - A Nuevo Parque Industrial,
              San Juan del Río, Qro. CP 76806
            </p>
          </div>

          <div className="mt-8 pt-8 border-t-2 border-[#94cf1c]/30">
            <p className="text-xs text-slate-500">
              Estos Términos y Condiciones constituyen un contrato de adhesión en términos
              del artículo 85 de la Ley Federal de Protección al Consumidor.
              Cualquier modificación será comunicada oportunamente a través de nuestro sitio web.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;